import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import CryptoJS from "crypto-js";
import { toast } from 'react-toastify';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { decryptToken } from '../utils/getToken';
// import decryptUserCookie from './utils/decryptUserCookie';

const DepartmentModal = ({ isOpen, setIsOpen, selectedCategory, setSelectedCategory, onSave, categories, setCategories, fetchCategories }) => {
    const [categoryName, setCategoryName] = useState('');
    const [position, setPosition] = useState('');
    const [status, setStatus] = useState(null);
    const [icon, setIcon] = useState("")
    const urlmain = API_BASE_URL
    const [images, setImages] = useState([]);
    const [showImageModal, setShowImageModal] = useState(false);
    const [category_id, setCategoryId] = useState("")
    const [loading, setLoading] = useState(false);
    // const userDetails = decryptUserCookie();
    const userDetails = getDecryptedUserFromCookie("gta_mainstateuser");
    const token = decryptToken("accessToken") || ""
    const fetchImages = async () => {
        try {
            const res = await fetch(`${urlmain}/api/images/${userDetails.main_id}`);
            const data = await res.json();
            setImages(data);
        } catch (error) {
            console.error(error);
        }
    };


    const handleImageSelect = (field, img) => {
        setIcon(`${urlmain}${img.url}`);
    };

    useEffect(() => {
        fetchImages();
    }, []);


    useEffect(() => {
        if (selectedCategory) {
            setCategoryId(selectedCategory.id)
            setCategoryName(selectedCategory.department_name);
            setPosition(selectedCategory.position);
            setIcon(selectedCategory.icon);
            setStatus({ value: selectedCategory.status, label: selectedCategory.status });
        } else {
            setCategoryName('');
            setPosition('');
            setIcon('');
            setStatus(null);
        }
    }, [selectedCategory]);





    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];


    const handleSubmit = async (e) => {
        e.preventDefault();
        const categoryData = {
            department_name: categoryName,
            status: status?.value || 'Active'
        };

        setLoading(true);
        const isEdit = !!selectedCategory?.id;
        const url = isEdit
            ? `${urlmain}/department/change/${selectedCategory.id}`
            : `${urlmain}/department`;
        const method = isEdit ? "PUT" : "POST";

        try {
            const response = await fetch(url, {
                method,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(categoryData),
            });

            const res = await response.json();
            if (response.ok) {
                if (!isEdit) {
                    fetchCategories();
                } else {
                    setCategories(prev =>
                        isEdit
                            ? prev.map(cat => cat.id === selectedCategory.id ? { ...categoryData, id: selectedCategory.id } : cat)
                            : [...prev, { ...categoryData, id: res.id }]
                    );
                }


                setCategoryName('');
                // fetchCategories();
                toast.success(isEdit ? "Department updated" : "Department added");
                setIsOpen(false);
                setSelectedCategory(null);

            } else {
                toast.error(res.message || "Operation failed");
            }
        } catch (error) {
            console.error("Error submitting category:", error);
            toast.error("Unexpected error occurred");
        } finally {
            setLoading(false);
        }
    };


    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" >
            <div
                className="custom-modal-content"

            >
                <h2 className="oms-modal-title">Department details</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="categoryName" className="oms-form-label">
                            Department
                        </label>
                        <input
                            type="text"
                            id="categoryName"
                            value={categoryName}
                            onChange={(e) => setCategoryName(e.target.value)}
                            placeholder="Enter Department Name"
                        />
                    </div>

                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        {
                            loading ? <button type="button">Submiting...</button> :
                                <button type="submit">Submit</button>
                        }
                    </div>
                </form>
            </div>
        </div>
    );
};

export default DepartmentModal;
